"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const react_redux_1 = require("react-redux");
const react_2 = require("redux-persist/integration/react");
const config_1 = require("../web/config");
const appRouteConfigs_1 = __importDefault(require("./appNavigation/appRouteConfigs"));
const analyticsComponent_1 = __importDefault(require("./components/analyticsComponent/analyticsComponent"));
const constants_1 = require("./constants/constants");
const store_1 = require("./store");
const utils_1 = require("./utils/utils");
const isWeb = react_native_1.Platform.OS === constants_1.WEB_TAG;
// Add material icons manually to web app. It is not required in mobile platforms because it is added automatically.
const IconModule = isWeb ? require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf') : null;
exports.default = () => (react_1.default.createElement(analyticsComponent_1.default, null,
    react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
        react_1.default.createElement(react_2.PersistGate, { loading: null, persistor: store_1.persistor },
            react_1.default.createElement(react_native_paper_1.Provider, null,
                IconModule && (react_1.default.createElement("style", { type: "text/css" }, `@font-face {
                            font-family: 'MaterialCommunityIcons';
                            src: url(${IconModule}) format('truetype');
                            }
                        `)),
                react_1.default.createElement(appRouteConfigs_1.default, null))))));
if (isWeb && config_1.PRODUCTION) {
    utils_1.registerServiceWorker();
}
